import type {DecorationSingleComponentPluginFunction} from '../../types'
import type {ComponentExportStructure} from '@wix/document-services-types'
import {SUPPORTED_DATA_TYPES} from './constants'

export const unpack: DecorationSingleComponentPluginFunction = (component: ComponentExportStructure) => {
    const type = component.data?.type
    if (!type || !SUPPORTED_DATA_TYPES.has(type)) {
        return
    }

    if (component.text !== undefined) {
        component.data.text = component.text
        delete component.text
    }
}
